export const US_PLUG = "US-Plug (Type A)";
export const UK_PLUG = "UK-Plug (Type G)";
export const EU_PLUG = "EU-Plug (Type C)";
export const AU_PLUG = "AU-Plug (Type I)";

// Per-plug single-unit SKU override. The storefront picks the single variant by
// option value, but UK GLORB orders must ship a dedicated SKU whose option
// value differs from the "UK-Plug (Type G)" label. When an entry exists here,
// the single variant is resolved by SKU first (see resolveSingleVariant), so
// the legacy GL02WH25G1 is no longer used for UK. Add/remove entries here to
// re-route a plug type to a different single SKU.
export const PLUG_SINGLE_SKU_OVERRIDE = { [UK_PLUG]: "GL02WH25C1UKPLUG" };

export const US_COUNTRIES = ["US", "CA", "MX", "PR", "VI", "GU", "AS", "MP"];
//"GB", "CY", "MT", "IE" for UK
export const UK_COUNTRIES = ["GB", "CY", "MT", "IE"];
export const EU_COUNTRIES = [
  "BE",
  "BG",
  "CZ",
  "DK",
  "DE",
  "EE",
  "GR",
  "ES",
  "FR",
  "HR",
  "IT",
  "LV",
  "LT",
  "LU",
  "HU",
  "NL",
  "AT",
  "PL",
  "PT",
  "RO",
  "SI",
  "SK",
  "FI",
  "SE",
  "AL",
  "AD",
  "AM",
  "BY",
  "BA",
  "GE",
  "IS",
  "KZ",
  "XK",
  "LI",
  "MK",
  "MD",
  "MC",
  "ME",
  "NO",
  "RU",
  "SM",
  "RS",
  "CH",
  "TR",
  "UA",
  "VA",
];
export const AU_COUNTRIES = ["AU", "NZ"];

// --- Multipack pricing display ---
// Multipacks are NOT separate Shopify variants/SKUs anymore. The cart always
// adds the single-unit variant × N (see ProductTemplate.handleAddToCart), and
// the real discount is applied at checkout by a Shopify AUTOMATIC quantity
// discount. These tables are DISPLAY ONLY - they reproduce the exact prices the
// old x2/x4 pack variants used to carry, so the product page shows identical
// numbers without depending on those SKUs existing.
//
// MULTIPACK_PRICING[region][qty] = { price, compareAt } - total pack price and
// its strikethrough/MSRP, per plug region (US / EU / UK / AU). The single (x1)
// is not listed: its price is the live single-variant base − UNIT_AUTO_DISCOUNT,
// strikethrough = the base. MUST stay in sync with the Shopify automatic
// quantity discount (else displayed price drifts from what checkout charges).
export const MULTIPACK_QUANTITIES = [2, 4];
export const MULTIPACK_PRICING = {
  // US discounts are percentage-based (the Shopify plan only allows market
  // -specific amounts on the primary market), so the charged total carries
  // cents the table cannot state: 10% off 398 is 358.20. Entries round AWAY
  // from the customer's favour, so the price shown is never lower than the
  // price charged.
  //
  // The 4-pack went to 1 GLORB free on 2026-10-07 (Simon): 4 × 199 less 199,
  // so 597 - 25% off in the US, a fixed €199 off in the EU and UK - read off
  // Shopify's checkout that day. That discount combines with free shipping
  // only, so a Halloween survey code does not apply on top of it.
  US: { 2: { price: 359, compareAt: 398 }, 4: { price: 597, compareAt: 796 } },
  EU: { 2: { price: 358, compareAt: 398 }, 4: { price: 597, compareAt: 796 } },
  UK: { 2: { price: 358, compareAt: 398 }, 4: { price: 597, compareAt: 796 } },
  AU: { 2: { price: 379, compareAt: 438 }, 4: { price: 716, compareAt: 876 } },
};

// Badge on a pack's setup card, by quantity. Four for the price of three is
// what the 4-pack is: 4 × 199 = 796 down to 597, in every market.
export const TIER_BADGE = { 4: "1 GLORB free" };

// Per-GLORB automatic discount set in Shopify on the single, which the
// Storefront API does not show: it returns the pre-discount base, so the
// product page subtracts this for the single's displayed price and strikes
// through the base. MUST equal the Shopify automatic discount, and be 0 when
// there is none.
//
// 0 since 2026-10-07: the autumn sale's €10 off was removed and the single is
// back at the 199 base. A future sale on singles sets it again here. Note what
// the autumn sale showed: Shopify applied it to the single only, never on top
// of the 2- and 4-pack quantity discounts (those are the MULTIPACK_PRICING
// figures), so a per-unit sale does not lower the pack prices.
export const UNIT_AUTO_DISCOUNT = 0;

// Free-shipping value shown as a saving ("$40 value") and rolled into the
// "Save $X total" figure on the product page.
export const FREE_SHIPPING_VALUE = 40;

// --- Product page hero ---
// Social-proof figure shown as a badge above the product title. Marketing
// claim, not derived from order data - update by hand.
//
// This counts GLORBs, which is the only social-proof figure we state publicly:
// ~8,000 units across ~5,000 homes (verified 2026-09). "8,000 homes" is
// therefore false - units and households are not interchangeable, and live ads
// have quoted both. Any new placement counts units, or says nothing.
export const UNITS_SOLD_LABEL = "8,000+";

// Hero warranty line. The site-wide claim is two years everywhere
// (policies/warranty-policy, faq, Small-faq, DetailsTwoColumns) - keep in sync.
export const WARRANTY_LABEL = "2-year warranty";

// The three purchase options on the product page, in display order. Every qty
// above 1 must exist in MULTIPACK_PRICING for all regions; qty 1 is the live
// single variant − UNIT_AUTO_DISCOUNT.
export const SETUP_TIERS = [
  { qty: 1, name: "Single", sub: "One GLORB" },
  { qty: 2, name: "Fill the room", sub: "Two, synced as one", popular: true },
  {
    qty: 4,
    name: "Every room, transformed",
    sub: "Four, fill every room with light",
  },
];

// The tier selected for a visitor who has not picked one - the pair, which is
// also the tier the cards badge as popular. Must be one of SETUP_TIERS.
export const DEFAULT_SETUP_QTY = 2;
